var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6111 3H6.16667C4.69391 3 3.5 4.19391 3.5 5.66667V18.1111C3.5 19.5839 4.69391 20.7778 6.16667 20.7778H15.1804C14.8935 20.2296 14.6889 19.6315 14.583 19.0001H8.31195L15.9435 11.3678L17.4235 12.8477C17.9733 12.5187 18.5801 12.2752 19.2256 12.1356L16.5725 9.48252L16.4815 9.40297C16.1331 9.1378 15.6337 9.16431 15.3155 9.48252L5.85423 18.9438C5.51722 18.8174 5.27734 18.4923 5.27734 18.1112V5.66672C5.27734 5.1758 5.67531 4.77783 6.16623 4.77783H18.6107C19.1016 4.77783 19.4996 5.1758 19.4996 5.66672V12.083C19.8249 12.0284 20.1591 12 20.5 12C20.7636 12 21.0232 12.017 21.2778 12.0499V5.66667C21.2778 4.19391 20.0839 3 18.6111 3ZM9.27789 6.55566C8.05059 6.55566 7.05566 7.55059 7.05566 8.77789C7.05566 10.0052 8.05059 11.0001 9.27789 11.0001C10.5052 11.0001 11.5001 10.0052 11.5001 8.77789C11.5001 7.55059 10.5052 6.55566 9.27789 6.55566ZM9.27832 8.33339C9.52378 8.33339 9.72276 8.53237 9.72276 8.77783C9.72276 9.02329 9.52378 9.22228 9.27832 9.22228C9.03286 9.22228 8.83388 9.02329 8.83388 8.77783C8.83388 8.53237 9.03286 8.33339 9.27832 8.33339Z",
    fill: "#77928B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 22L17.5 20.6L19.6 18.5L17.5 16.4L18.9 15L21 17.1L23.1 15L24.5 16.4L22.425 18.5L24.5 20.6L23.1 22L21 19.925L18.9 22Z",
    fill: "#FF4550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c69fe9e48f9c36216d974264621293a8.svg";
export { ForwardRef as ReactComponent };